import React, { useEffect } from 'react';
import { Modal, Form, Input, Button, Switch } from 'antd';
import { customBaseUrl, httpPut } from '../../store/http';
import { NotificationManager } from 'react-notifications';
import Swal from 'sweetalert2';
import { showLoader, hideLoader } from '../../utils/loader';

const UpdateMarketerModal = ({ visible, onCancel, onUpdate, marketerData, fetchData }) => {
    const [form] = Form.useForm();

    useEffect(() => {
        if (visible && marketerData) {
            const [firstName, ...lastNameParts] = marketerData.fullName.split(' ');
            const lastName = lastNameParts.join(' ');
            form.setFieldsValue({
                firstName: firstName,
                lastName: lastName,
                phoneNumber: marketerData.phoneNumber,
                email: marketerData.marketerUserEmail,
                // active: marketerData.active, // Removed as 'active' is not in the update payload
            });
        }
    }, [visible, marketerData, form]);

    const handleUpdate = async () => {
        try {
            const values = await form.validateFields();
            const payload = {
                email: values.email,
                firstName: values.firstName,
                lastName: values.lastName,
                phoneNumber: values.phoneNumber,
                // active: values.active, // 'active' is not in the provided payload structure
            };
            showLoader();
            const res = await httpPut(`${customBaseUrl.cardUrl}/cms/admin/marketers/update`, payload);
            hideLoader();
            if (res.status === true) {
                NotificationManager.success('Marketer details updated successfully!');
                form.resetFields();
                onUpdate(); // Refresh the list
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: res.message,
                });
            }
        } catch (error) {
            hideLoader();
            console.error('Failed to update marketer:', error);
            NotificationManager.error('An error occurred while updating marketer.');
        }
    };

    return (
        <Modal
            visible={visible}
            title="Update Marketer Details"
            onCancel={onCancel}
            footer={[
                <Button key="back" onClick={onCancel}>
                    Cancel
                </Button>,
                <Button key="submit" type="primary" loading={false} onClick={handleUpdate}>
                    Update
                </Button>,
            ]}
        >
            <Form
                form={form}
                layout="vertical"
                name="update_marketer_form"
            >
                <Form.Item
                    name="firstName"
                    label="First Name"
                    rules={[{ required: true, message: 'Please enter first name!' }]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    name="lastName"
                    label="Last Name"
                    rules={[{ required: true, message: 'Please enter last name!' }]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    name="phoneNumber"
                    label="Phone Number"
                    rules={[{ required: true, message: 'Please enter phone number!' }]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    name="email"
                    label="Email"
                    rules={[{ required: true, type: 'email', message: 'Please enter a valid email!' }]}
                >
                    <Input disabled />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default UpdateMarketerModal;
